import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { tap, take, map } from 'rxjs/operators';

import { IAuroraState } from '@apps/aurora.state';
import * as fromAuthStore from '@apps/auth/store';
import { MfaSetup } from 'src/app/_apps/auth/api/models/mfa-setup';

@Component({
    selector: 'aa-two-factor-setup',
    templateUrl: './two-factor-setup.component.html',
    styleUrls: [
        './two-factor-setup.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TwoFactorSetupComponent implements OnInit {
    public formGroup: UntypedFormGroup;
    public readonly CodeField = 'code';
    public mfaQrCodeImage: string;
    private idToken: string;
    private mfaSetup: MfaSetup = { secretKey: '', qrCodeBase64: '' } as MfaSetup;

    constructor(
        private route: ActivatedRoute,
        private store: Store<IAuroraState>,
        private formBuilder: UntypedFormBuilder
    ) {
    }

    ngOnInit() {
        this.route.paramMap
            .pipe(
                take(1),
                tap((params: ParamMap): void => {
                    this.idToken = params.get('idToken');
                    this.mfaSetup.secretKey = params.get('secretKey');
                    this.mfaSetup.qrCodeBase64 = params.get('qrCodeBase64');

                    if (this.mfaSetup.qrCodeBase64) {
                        this.mfaQrCodeImage = "data:image/png;base64," + this.mfaSetup.qrCodeBase64;
                    }

                    this.initFormGroup();
                })
            )
            .subscribe();
    }

    onSubmit = () => {
        if (this.formGroup.invalid) {
            for (const control in this.formGroup.controls) {
                this.formGroup.controls[control].markAsDirty();
            }

            return;
        }

        const verifyCode = this.formGroup.get(this.CodeField).value;

        this.store.dispatch(fromAuthStore.AuthLoginStoreActions.AuthTwoFactorSetupVerifyRequested({ idToken: this.idToken, verifyCode }));
    };

    private initFormGroup() {
        this.formGroup = this.formBuilder.group({
            [this.CodeField]: [
                '',
                Validators.required
            ]
        });
    }
}
